(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-second-section"] && !Shopify.designMode) return;
  try {
    
  
   $('.show-more').click(function(e) {
        e.preventDefault();
        $(this).text(function(i, t) {
          return t == 'Show less ...' ? 'Show more ...' : 'Show less ...';
        }).prev('.complete-text').slideToggle()
      });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestseller-slider"] && !Shopify.designMode) return;
  try {
      
     $('.bestsellerslider').owlCarousel({      
          nav: true, 
          navText: ["<img src='https://cdn.shopify.com/s/files/1/1002/0080/files/prev-arrow-bestseller.png'>","<img src='https://cdn.shopify.com/s/files/1/1002/0080/files/next-arrow-bestseller.png'>"], 
          margin: 32,  
          dots: false,  
          items: 4,        
          loop: false,   
          autoplay: false, 
          responsiveClass: true, 
          responsive: {   
              0: { 
                  items: 1, 
                  loop: true,
                  stagePadding: 20         
              },  
              570: { 
                  items: 2,
                  loop: true,
                  stagePadding: 20     
              },    
              767: { 
                  items: 3,
                  stagePadding: 60      
              },  
              1200: {  
                  items: 4,
                  stagePadding: 100 
              }
          }
        });         
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
  
  $('.show-more').click(function(e) {
        e.preventDefault();
        $(this).text(function(i, t) {
          return t == 'Show less ...' ? 'Show more ...' : 'Show less ...';
        }).prev('.complete-text').slideToggle()
      });
  

  } catch(e) { console.error(e); }
})();
})();
